"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDriveForDisplay = formatDriveForDisplay;
var time_1 = require("../helpers/time");
// Compute display properties for a drive.
// Normalizes all time formatting to formatDateTime(date, "h:mm A") -> "1:30 pm"
function formatDriveForDisplay(drive) {
    var sessionLength = typeof drive.session_length === "string"
        ? parseInt(drive.session_length, 10)
        : drive.session_length;
    var startDate = (0, time_1.timeStringToDate)(drive.start_time);
    var endDate = (0, time_1.addMinutes)(startDate, sessionLength);
    var driveDateTime = new Date(drive.drive_date + " " + drive.start_time);
    var driveEndDateTime = (0, time_1.addMinutes)(driveDateTime, sessionLength);
    var now = new Date();
    var _a = (0, time_1.minutesToHoursAndMinutes)(sessionLength), hours = _a.hours, minutes = _a.minutes;
    return {
        startTime: (0, time_1.formatDateTime)(startDate, "h:mm A"),
        endTime: (0, time_1.formatDateTime)(endDate, "h:mm A"),
        duration: (0, time_1.formatDuration)(sessionLength),
        inProgress: now >= driveDateTime && now <= driveEndDateTime,
        inPast: (0, time_1.isAfter)(now, driveDateTime),
        sessionLengthHours: String(hours),
        sessionLengthMinutes: String(minutes),
    };
}
